export default "__VITE_ASSET__cm$hwX8i__"